/** @format */

export const EnvelopeSmall = ({color}) => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M13.6875 3C14.4121 3 15 3.55964 15 4.25C15 4.64323 14.8059 5.01302 14.475 5.25L8.525 9.5C8.21328 9.72135 7.78672 9.72135 7.475 9.5L1.525 5.25C1.1945 5.01302 1 4.64323 1 4.25C1 3.55964 1.58762 3 2.3125 3H13.6875ZM6.95 10.1667C7.57344 10.612 8.42656 10.612 9.05 10.1667L15 5.91667V11.3333C15 12.2526 14.2152 13 13.25 13H2.75C1.7834 13 1 12.2526 1 11.3333V5.91667L6.95 10.1667Z"
                fill={color}
            />
        </svg>
    );
};
